// Apollo House Student Living website data

export const companyInfo = {
  name: "Apollo House",
  tagline: "Affordable Student Accommodation",
  domain: "www.aplhouse.co.za",
  emails: {
    general: "info@aplhouse.co.za",
    students: "student@aplhouse.co.za"
  },
  social: {
    facebook: "https://www.facebook.com/profile.php?id=61590266027282",
    tiktok: "https://www.tiktok.com/@aphouse1",
    linkedin: "https://www.linkedin.com/in/aphouse-undefined-9067653b6/"
  },
  phone: {
    whatsapp: "27615290223",
    whatsappDisplay: "061 529 0223",
    tel: "016 933 4821"
  },
  addresses: [
    {
      name: "CW6 Residence",
      street: "25 Kipling Street",
      area: "CW6",
      city: "Vanderbijlpark",
      postalCode: "1900"
    },
    {
      name: "Malida Court",
      street: "33 Frikkie Meyer Boulevard",
      area: "CE2",
      city: "Vanderbijlpark",
      postalCode: "1900"
    },
    {
      name: "Huguenot Court",
      street: "3 Chestnut Street",
      area: "Three Rivers North",
      city: "Vereeniging",
      postalCode: "1929"
    },
    {
      name: "Peacehaven (Coming Soon)",
      street: "70 General Hertzog Road",
      area: "Peacehaven",
      city: "Vereeniging",
      postalCode: "1939"
    }
  ]
};

export const pricing = {
  nsfas: {
    rate: "R 4,700",
    period: "per month",
    label: "NSFAS Rate"
  },
  bursaryPrivate: {
    rate: "R 5,500",
    period: "per month",
    label: "Bursary/Private Rate"
  }
};

export const locations = [
  {
    id: 1,
    name: "CW6 RESIDENCE",
    street: "25 Kipling Street",
    city: "Vanderbijlpark",
    color: "orange",
    image: "https://images.unsplash.com/photo-1641443084236-b29fa3c673a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHw0fHxzdHVkZW50JTIwYWNjb21tb2RhdGlvbiUyMGJ1aWxkaW5nJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzcwOTkxNDc2fDA&ixlib=rb-4.1.0&q=85&w=600",
    link: "/locations/cw6",
    description: "Heart of the action. Close to campus.",
    status: "available"
  },
  {
    id: 2,
    name: "MALIDA COURT",
    street: "33 Frikkie Meyer Boulevard, CE2",
    city: "Vanderbijlpark",
    color: "orange",
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_vanderbijlpark-dorms/artifacts/cbmoh58k_WhatsApp%20Image%202026-09-03%20at%2011.00.25.webp",
    link: "/locations/malida",
    description: "Modern living in a prime location.",
    status: "available"
  },
  {
    id: 3,
    name: "HUGUENOT COURT",
    street: "3 Chestnut Street, Three Rivers North",
    city: "Vereeniging",
    color: "blue",
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_vanderbijlpark-dorms/artifacts/qfvb747t_WhatsApp%20Image%202026-09-03%20at%2011.00.32.webp",
    link: "/locations/huguenot",
    description: "Peaceful environment in Vereeniging.",
    status: "available"
  },
  {
    id: 4,
    name: "PEACEHAVEN",
    street: "70 General Hertzog Road, Peacehaven",
    city: "Vereeniging",
    color: "blue",
    image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBidWlsZGluZ3xlbnwwfHx8fDE3MTcwMDAwMDB8MA&ixlib=rb-4.1.0&q=85&w=600",
    link: "/locations/peacehaven",
    description: "New residence coming soon!",
    status: "coming-soon"
  }
];

export const heroSlides = [
  {
    id: 1,
    image: "https://images.pexels.com/photos/6140610/pexels-photo-6140610.jpeg?auto=compress&cs=tinysrgb&w=1200",
    tagline: "Live",
    subline: "Study",
    endline: "Thrive"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1627556704243-5f0771d90783?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxBZnJpY2FuJTIwYmxhY2slMjBzdHVkZW50cyUyMGdyYWR1YXRpb24lMjBjZWxlYnJhdGluZyUyMHVuaXZlcnNpdHl8ZW58MHx8fHwxNzgwNzQ4MzE4fDA&ixlib=rb-4.1.0&q=85&w=1200",
    tagline: "Affordable",
    subline: "Student",
    endline: "Living"
  },
  {
    id: 3,
    image: "https://images.pexels.com/photos/5940710/pexels-photo-5940710.jpeg?auto=compress&cs=tinysrgb&w=1200",
    tagline: "NSFAS",
    subline: "Accredited",
    endline: "Housing"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1686213011642-b25f94b95b96?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxBZnJpY2FuJTIwYmxhY2slMjBzdHVkZW50cyUyMGdyYWR1YXRpb24lMjBjZWxlYnJhdGluZyUyMHVuaXZlcnNpdHl8ZW58MHx8fHwxNzgwNzQ4MzE4fDA&ixlib=rb-4.1.0&q=85&w=1200",
    tagline: "Your",
    subline: "Home Away",
    endline: "From Home"
  }
];

export const amenities = [
  { id: 1, name: "Free WiFi", icon: "Wifi" },
  { id: 2, name: "Swimming Pools", icon: "Waves" },
  { id: 3, name: "Cafeteria", icon: "Utensils" },
  { id: 4, name: "Study Rooms", icon: "BookOpen" },
  { id: 5, name: "Gaming Rooms", icon: "Gamepad2" },
  { id: 6, name: "Computer Facilities", icon: "Monitor" },
  { id: 7, name: "Printing Services", icon: "Printer" },
  { id: 8, name: "Table Soccer", icon: "Trophy" },
  { id: 9, name: "24/7 Security", icon: "Shield" }
];

export const features = [
  { id: 1, title: "24/7", subtitle: "Security", icon: "Shield" },
  { id: 2, title: "Free", subtitle: "WiFi", icon: "Wifi" },
  { id: 3, title: "NSFAS", subtitle: "Accredited", icon: "BadgeCheck" },
  { id: 4, title: "Study", subtitle: "Rooms", icon: "BookOpen" },
  { id: 5, title: "Swimming", subtitle: "Pools", icon: "Waves" },
  { id: 6, title: "Cafeteria", subtitle: "On-site", icon: "Utensils" }
];

export const navLinks = [
  { id: 1, label: "Home", href: "/" },
  { id: 2, label: "Student Life", href: "/student-life" },
  { id: 3, label: "Safety & Support", href: "/safety" },
  { id: 4, label: "Resident Services", href: "/services" },
  { id: 5, label: "FAQs", href: "/faqs" },
  { id: 6, label: "Contact", href: "/contact" }
];

export const accommodationContent = {
  title: "Affordable Student Accommodation",
  description: "Welcome to Apollo House – your home away from home in Vanderbijlpark. We provide quality, affordable student accommodation designed to help you succeed in your studies. Our residences are NSFAS accredited and conveniently located near major educational institutions.",
  extendedDescription: "At Apollo House, we understand that a comfortable living environment is essential for academic success. That's why we've created spaces that combine affordability with quality amenities. Our modern facilities include free WiFi, swimming pools, a cafeteria, dedicated study rooms, gaming rooms, computer and printing facilities, and recreational areas including table soccer.",
  philosophy: "We believe every student deserves access to safe, comfortable, and supportive accommodation. Our team is committed to providing 24/7 support and maintaining a community where students can thrive academically and socially."
};

export const whyUsContent = {
  title: "Why Apollo House?",
  description: "Thousands of students choose Apollo House as their accommodation of choice each year. With NSFAS-accredited facilities and competitive rates, we make quality student living accessible. All our buildings feature 24/7 security, CCTV surveillance, and controlled access. Enjoy modern amenities including free WiFi, swimming pools, a cafeteria, study rooms, gaming rooms, computer facilities, and more – everything you need to excel in your studies while enjoying student life."
};

export const faqs = [
  {
    id: 1,
    category: "Pricing & Payment",
    questions: [
      { q: "What are the monthly rates?", a: "NSFAS students pay R 4,700 per month. Bursary and private students pay R 5,500 per month." },
      { q: "Is the accommodation NSFAS accredited?", a: "Yes, Apollo House is fully NSFAS accredited. We work directly with NSFAS to ensure seamless payment processing." },
      { q: "What is included in the rent?", a: "Your rent includes accommodation, WiFi, access to all amenities (swimming pool, study rooms, gaming rooms, etc.), security, and utilities." }
    ]
  },
  {
    id: 2,
    category: "Facilities & Amenities",
    questions: [
      { q: "What amenities are available?", a: "We offer free WiFi, swimming pools, cafeteria, study rooms, gaming rooms, computer and printing facilities, and table soccer." },
      { q: "Is there security on-site?", a: "Yes, we have 24/7 security personnel, CCTV surveillance throughout the premises, and controlled access systems." }
    ]
  },
  {
    id: 3,
    category: "Application & Move-in",
    questions: [
      { q: "How do I apply?", a: "You can apply online through our website or visit our offices in person. You'll need your ID, proof of registration, and funding confirmation." },
      { q: "When can I move in?", a: "Move-in dates align with the academic calendar. Contact us to book a viewing and discuss available move-in dates." }
    ]
  }
];

export const applicationSteps = [
  { step: 1, title: "Complete Application", description: "Fill out our online application form with your personal details" },
  { step: 2, title: "Submit Documents", description: "Upload your ID, proof of registration, and funding confirmation" },
  { step: 3, title: "Application Review", description: "Our team will review your application within 2-3 business days" },
  { step: 4, title: "Confirmation", description: "Receive your acceptance and lease agreement" },
  { step: 5, title: "Move In", description: "Complete payment and move into your new home" }
];

export const studentLifeContent = {
  title: "Student Life at Apollo House",
  intro: "More than just accommodation – it's a community where you'll make lifelong friends and unforgettable memories.",
  sections: [
    {
      title: "Academic Support",
      description: "Our dedicated study rooms provide the perfect environment for focused learning. With free WiFi and computer facilities, you'll have everything you need to excel in your studies.",
      image: "https://images.pexels.com/photos/5940710/pexels-photo-5940710.jpeg?auto=compress&cs=tinysrgb&w=600"
    },
    {
      title: "Recreation & Fun",
      description: "Unwind after a long day of studying with our gaming rooms, swimming pools, and table soccer. There's always something fun to do at Apollo House.",
      image: "https://images.unsplash.com/photo-1753194931548-065891743746?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHw0fHxyZXNpZGVudGlhbCUyMHN3aW1taW5nJTIwcG9vbCUyMHN1bm55JTIwZGF5fGVufDB8fHx8MTc3MDk5MjAzNHww&ixlib=rb-4.1.0&q=85&w=600"
    },
    {
      title: "Community Events",
      description: "From study groups to social gatherings, we organize regular events to help you connect with fellow students and build lasting friendships.",
      image: "https://images.unsplash.com/photo-1627556704283-452301a45fd0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxBZnJpY2FuJTIwYmxhY2slMjBzdHVkZW50cyUyMGdyYWR1YXRpb24lMjBjZWxlYnJhdGluZyUyMHVuaXZlcnNpdHl8ZW58MHx8fHwxNzgwNzQ4MzE4fDA&ixlib=rb-4.1.0&q=85&w=600"
    }
  ]
};

export const safetyContent = {
  title: "Your Safety is Our Priority",
  intro: "At Apollo House, we've invested in comprehensive security measures to ensure you feel safe and secure at all times.",
  features: [
    {
      title: "24/7 Security Personnel",
      description: "Our trained security team is on duty around the clock to ensure your safety.",
      icon: "Shield"
    },
    {
      title: "CCTV Surveillance",
      description: "State-of-the-art camera systems monitor all common areas and entrances.",
      icon: "Camera"
    },
    {
      title: "Controlled Access",
      description: "Biometric and card access systems ensure only authorized residents enter the premises.",
      icon: "KeyRound"
    },
    {
      title: "Emergency Response",
      description: "Quick response protocols and emergency contacts available 24/7.",
      icon: "Phone"
    },
    {
      title: "Fire Safety",
      description: "Fire extinguishers, smoke detectors, and evacuation plans in place throughout.",
      icon: "Flame"
    },
    {
      title: "Support Team",
      description: "Dedicated support staff available to assist with any concerns or issues.",
      icon: "Users"
    }
  ]
};

export const servicesContent = {
  title: "Resident Services",
  intro: "We're here to make your stay as comfortable as possible with a range of services designed for student success.",
  services: [
    {
      title: "Maintenance",
      description: "Report issues easily and get them resolved quickly by our maintenance team.",
      icon: "Wrench"
    },
    {
      title: "Housekeeping",
      description: "Common areas are cleaned regularly to maintain a pleasant environment.",
      icon: "Sparkles"
    },
    {
      title: "IT Support",
      description: "Get help with WiFi connectivity and computer access issues.",
      icon: "Laptop"
    },
    {
      title: "Laundry Facilities",
      description: "On-site laundry facilities available for all residents.",
      icon: "Shirt"
    },
    {
      title: "Mail & Parcels",
      description: "Secure mail room for receiving your packages and correspondence.",
      icon: "Mail"
    },
    {
      title: "Room Allocation",
      description: "We help match you with compatible roommates and preferred room types.",
      icon: "Home"
    }
  ]
};
